/**
 * @overview 菜单列表
 * @author 3173
 * @date 2019-12
 */

import React from 'react';
import { connect } from 'dva';
import { templateConfig, reduxTemplateCofig } from './config'
import { framework_tool, component_tool ,utils_tool} from '../../../tool'
let { WizContainer, WizReduxTemplate } = framework_tool;
let { WizNotice, WizBrowserExport } = component_tool;
let { checkStrLength } = utils_tool;
class MenuList extends WizContainer {

  componentName = 'MenuList';

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  _handleCMD(nextProps, nextState, key) {
    let o = nextProps[key]
    if (o['success']) {
      wizNotice.success(o['msg'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }

  _handleTreeData(nextProps, nextState, key) {
    let o = nextProps[key]
    let len = 10
    if (o['success']) {
      let f = (v) => {
        v && v.forEach(val => {
          val['title'] = checkStrLength(val['title'], len);
          if (val['children'] && val['children'].length > 0) {
            f(val['children'])
          }
        });
      }
      f(o['data'])
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  _handleFile(nextProps, nextState, key) {
    let o = nextProps[key]
    let columnDefs = [
      {
        headerName: '',
        width: 30,
        field: 'rowIndex',
        hidden: true,
        suppressMovable: true,
        cellStyle: {
          textAlign: 'center',
          padding: '5px 0',
          color: '#595959',
          backgroundColor: '#f0f0f0',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: '500',
          boxShadow: '0 2px 0px 0 rgba(0,0,0,0.15)',
        },
      },
      {
        headerName: '菜单名称',
        field: 'name',
        width: 20,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
          font:{ }
        },
      },
      {
        headerName: '编号',
        field: 'number',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '类型',
        field: 'typeName',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '菜单连接',
        field: 'url',
        width: 20,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '菜单元素',
        field: 'elements',
        width: 25,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '菜单角色',
        field: 'rolesName',
        width: 25,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center',wrapText:true },
        },
      },
      {
        headerName: '状态',
        field: 'disabledName',
        width: 10,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '上级菜单',
        field: 'parentName',
        width: 20,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '上级菜单编号',
        field: 'parentNumber',
        width: 20,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center' },
        },
      },
      {
        headerName: '介绍',
        field: 'remark',
        width: 30,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'middle', horizontal: 'center',wrapText:true  },
        },
      },
      {
        headerName: '创建时间',
        field: 'createTime',
        width: 15,
        cellStyle: {
          textAlign: 'left',
        },
        style: {
          alignment: { vertical: 'bottom', horizontal: 'center' },
        },
      }
    ]
    if (o['success']) {
      let data = o['data']

      let _data = []
      data && data.forEach(d => {
        let _d = { ...d }
        let elements = '';  
        d.menuElements && d.menuElements.forEach(e=>{
          elements += e.name + ',';
        })
        elements = elements.substring(0,elements.length-1);
        _d.elements = elements;
       _data.push(_d) 
      });


      WizBrowserExport({
        title: '菜单信息',
        sheetName: '菜单信息',
        columns: columnDefs.filter((_, index) => index),
        rows: _data,
        filename: '菜单信息.xlsx',
      })
      return true;
    } else {
      wizNotice.error(o['msg'])
      return false;
    }
  }


  
  _render() {
    let _reduxTemplateCofig = reduxTemplateCofig({
      templateConfig,
      apiDataFormat: {
        changeDisable:this._handleCMD,
        treeData: this._handleTreeData,
        export: this._handleFile
      },
    })
    return <WizReduxTemplate {..._reduxTemplateCofig} />
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(MenuList);
